import { render, staticRenderFns } from "./MyUsersSetSpendLimit.vue?vue&type=template&id=019f13b2&scoped=true"
import script from "./MyUsersSetSpendLimit.vue?vue&type=script&lang=js"
export * from "./MyUsersSetSpendLimit.vue?vue&type=script&lang=js"
import style0 from "./MyUsersSetSpendLimit.vue?vue&type=style&index=0&id=019f13b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f13b2",
  null
  
)

export default component.exports